import React, { useEffect, useState } from 'react';
import './services-style.css';
import './services-details-style.css';
import { RiArrowRightSLine } from "react-icons/ri";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { BsCheck } from "react-icons/bs";
import { FiArrowUpRight } from "react-icons/fi";
import Button from 'react-bootstrap/Button';
import { Accordion } from 'react-bootstrap';
import { DieselGenratorFive, DieselGenratorImg1, DieselGenratorImg2, DieselGenratorImg3, DieselGenratorImg4, DieselGenratorImg5, PartnerLogoFour, PartnerLogoOne, PartnerLogoThree, PartnerLogoTwo } from '../../assets';
import ConsultationForm from '../../components/common/consultation';
import BlogList from '../../components/blog';
import Continent from '../../components/continent/Continent';
import GetaQuote from '../../components/common/getquote/GetaQuote';
import Metatags from '../../components/meta/metatags';
import { FRONT_BASE_URL } from '../../constants/commonConstants';

import Slider from "react-slick";
import axios from 'axios';

function DieselGenerator() {
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [metaKeyword, setMetaKeyword] = useState('');
    const [focusKeyword, setFocusKeyword] = useState('');
    const [ogTitle, setOgTitle] = useState('');
    const [ogDescription, setOgDescription] = useState('');
    useEffect(() => {
        document.title = 'Services';
        fetchSeo();
    }, []);

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const fetchSeo = async () => {
        const { data } = await axios.get(`getseo/diesel-generator`);
        /* SEO - Start */
        setMetaTitle(data.data.meta_title)
        setMetaKeyword(data.data.meta_keyword)
        setMetaDescription(data.data.meta_description)
        setFocusKeyword(data.data.focus_keyword)
        setOgTitle(data.data.og_title)
        setOgDescription(data.data.og_description)
        /* SEO - End */
    };

    return (
        <div className='dieselGeneratorPageCover'>
            <Metatags
                title={metaTitle}
                description={metaDescription}
                keywords={metaKeyword}
                focusedkeyword={focusKeyword}
                ogTitle={ogTitle}
                ogDescription={ogDescription}
                ogImage=''
                canonicalURL={FRONT_BASE_URL + `/diesel-generator`}
            />

            <GetaQuote show={show} onHide={() => setShow(false)} />

            <div className='CustContainer'>
                <div className='BreadcrumbItem'>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><RiArrowRightSLine /></li>
                        <li>Diesel Generator</li>
                    </ul>
                </div>
            </div>

          

            <div className='CustContainer'>
                <div className='TransfServpageixiimg'>
                    <div className='TransfServpaggImg'>
                        <img src={DieselGenratorImg1} alt="Diesel Generator Sets" />
                    </div>
                    <div className='TransfServpaggTxt'>
                        <div className='TransfServpagTxtLeft'>
                            <h1>Diesel Generator Sets (DG Sets)</h1>
                            <h2>Diesel Generator Supplier and Exporter from India</h2>
                            <p><span>VoltageShift Engineering Solutions LLP</span>  is a trusted and leading <span>diesel generator manufacturer, supplier, and exporter,</span> delivering high-performance <span>Diesel Generators (DG Sets / Gensets)</span> for residential, industrial, commercial, and infrastructure projects across the global market. As a reliable <span>diesel generator supplier in UAE, including Dubai, and exporter to Africa,</span> we support EPC contractors, project developers, and industrial clients with efficient and cost-effective power solutions.</p>
                            <p>We offer a comprehensive range of <span>diesel generator sets from 7.5 kVA to 3750 kVA and above,</span> available in <span>415V Low Voltage (LV) and 11kV High Voltage (HV) output configurations,</span> including <span>silent generator sets, acoustic enclosure type diesel generators, containerised diesel generators, industrial diesel generators, mobile generators, and customised diesel generator solutions,</span> designed for reliable performance in demanding environments. Our DG sets are suitable for both <span>prime power and standby power applications,</span> ensuring uninterrupted and continuous power
                            supply.</p>
                            <p>Our diesel generators are powered by globally recognized engines such as <span>Cummins, Perkins, and Caterpillar,</span> ensuring high efficiency, fuel optimization, low maintenance, and long service life. We provide <span>fast delivery, flexible configurations, and competitive pricing</span> to meet urgent and largescale project requirements.</p>
                            <Button onClick={() => setShow(true)}>Get A Quotation</Button>
                            {/* <a href={DieselGenratorImg2} download><FaCloudDownloadAlt /> Download Brochure</a> */}
                            <a href="https://wa.me/919974466992" target="_blank" rel="noopener noreferrer" className="whatsappBtn"><FaWhatsapp /> WhatsApp</a>
                        </div>
                        <div className='TransfServpagTxtReft'>
                            <h3>Key Features of Diesel Generator Sets</h3>
                            <h6>VoltageShift diesel generators are engineered to deliver reliable, efficient, and high-performance power solutions for industrial, commercial, and infrastructure projects across the UAE and Africa.</h6>
                            <p><BsCheck /> Wide Capacity Range from 7.5 kVA to 3750 kVA and above</p>
                            <p><BsCheck /> Complete DG Solutions including enclosures, fuel systems, exhaust systems, and control panels</p>
                            <p><BsCheck /> Multiple Configuration Options: Open Type, Silent, and Containerised DG Sets</p>
                            <p><BsCheck /> Flexible Voltage Options: 110V to 415V (LV) and 11kV (HV) </p>
                            <p><BsCheck /> Globally Trusted Engine Brands such as Cummins, Perkins, Caterpillar, and others</p>
                            <p><BsCheck /> Advanced Control & Synchronization using ComAp and DSE controllers </p>
                            <p><BsCheck /> High Efficiency and Fuel Opimization </p>
                            <p><BsCheck /> High Reliability for Continuous Operation </p>
                            <p><BsCheck /> Low Maintenance and Long Service Life </p>
                            <p><BsCheck /> Designed for Harsh UAE & Africa Conditions </p>
                            <p><BsCheck /> 24x7 Service Support </p>
                            <p><BsCheck /> Wide After-Sales & Spare Parts Support </p>
                            <p><BsCheck /> Fast Delivery & Export Support </p>
                            <p><BsCheck /> Customised Solutions as per Project Requirements </p>
                            <p><BsCheck /> Compliance with International Standards </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='CustContainer'>
                <div className='Traasfainboxset'>
                    <div className='TraasfainboxLeft'>
                        <img src={DieselGenratorImg2} alt="Low Horsepower (LHP) Diesel Generator Sets" />
                    </div>
                    <div className='TraasfainboxRight'>
                        <h3>Low Horsepower (LHP) Diesel Generator Sets</h3>
                        <p><BsCheck /> Range: 7.5 kVA – 160 kVA</p>
                        <p><BsCheck /> Output Voltage: 110V to 415V (Standard LV Supply)</p>
                        <p><BsCheck /> Engine: Cummins / Perkins / Kirloskar / Mahindra Powerol / Ashok Leyland / Eicher / Greaves Cotton</p>
                        <p><BsCheck /> Frequency: 50 Hz / 60 Hz</p>
                        <p><BsCheck /> Phase: Three Phase</p>
                        <p><BsCheck /> Cooling System: Air Cooled / Water Cooled</p>
                        <p><BsCheck /> Emission Standards: As per applicable international and project requirements</p>
                    </div>
                </div>
                <div className='Traasfainboxset'>
                    <div className='TraasfainboxLeft'>
                        <h3>Medium Horsepower (MHP) Diesel Generator Sets</h3>
                        <p><BsCheck /> Range: 180 kVA - 500 kVA</p>
                        <p><BsCheck /> Output Voltage: 110V to 415V (Standard LV Supply), 11kV available through step-up transformer solutions</p>
                        <p><BsCheck /> Engine: Cummins / Perkins / Volvo Penta / Kirloskar / Mahindra Powerol / Ashok Leyland</p>
                        <p><BsCheck /> Frequency: 50 Hz / 60 Hz</p>
                        <p><BsCheck /> Phase: Three Phase</p>
                        <p><BsCheck /> Cooling System: Water Cooled</p>
                        <p><BsCheck /> Emission Standards: As per applicable international and project requirements</p>
                    </div>
                    <div className='TraasfainboxRight'>
                        <img src={DieselGenratorImg3} alt="Medium Horsepower (MHP) Diesel Generator Sets" />
                    </div>
                </div>
                <div className='Traasfainboxset'>
                    <div className='TraasfainboxLeft'>
                        <img src={DieselGenratorImg4} alt="High Horsepower (HHP) Diesel Generator Sets" />
                    </div>
                    <div className='TraasfainboxRight'>
                        <h3>High Horsepower (HHP) Diesel Generator Sets</h3>
                        <p><BsCheck /> Range: 500 kVA - 3750 kVA+</p>
                        <p><BsCheck /> Output Voltage:  415V (LV) / 11kV (HV) configurations available</p>
                        <p><BsCheck /> Frequency: 50 Hz / 60 Hz</p>
                        <p><BsCheck /> Phase: Three Phase</p>
                        <p><BsCheck /> Cooling System: Water Cooled</p>
                        <p><BsCheck /> Operation Mode: Prime Power / Continuous Power / Standby Power</p>
                        <p><BsCheck /> Configuration: Open Type / Silent (Acoustic Enclosure) Type / Containerised DG Sets</p>
                        <p><BsCheck /> Engine Make: Cummins / Perkins / Caterpillar / Volvo Penta / Kirloskar (as per requirement)</p>
                        <p><BsCheck /> Emission Standards: As per applicable international and project requirements</p>
                    </div>
                    
                </div>
            </div>

            {/* <div className='OurservofferBoxCov'>
                <div className='CustContainer'>
                    <div className='OurservofferBoxTitle'>
                        <h3>Our Range of Diesel Generator Sets</h3>
                        <p>As one of the most reliable <span>diesel generator suppliers and exporters,</span> VoltageShift Engineering Solutions LLP offers a comprehensive range of <span>Diesel Generator Sets (DG Sets)</span> to meet diverse project requirements across the UAE and Africa. Our DG sets are available in various capacity ranges and configurations, ensuring flexibility for different industrial and commercial applications. </p>
                    </div>
                    <div className='OurservofferBoxSrvs'>
                        <div className='OurservofferBoxSrvIner'>
                            <a href="/contact-us">
                                <div className='OurservofferBoxSrvImg'>
                                    <img src={DieselGenratorImg2} alt="Low Horsepower Diesel Generator Sets" />
                                </div>
                                <div className='OurservofferBoxSrvTxt'>
                                    <h3>Low Horsepower (LHP) Diesel Generator Sets</h3>
                                    <p>Range: 7.5 kVA – 160 kVA <FiArrowUpRight /></p>
                                </div>
                                <div className='OurservofferBoxSrvBox'>
                                    <h3>Low Horsepower (LHP) DG Sets</h3>
                                    <p><BsCheck /> Output Voltage: 110V to 415V (Standard LV Supply)</p>
                                    <p><BsCheck /> Engine: Cummins / Perkins / Kirloskar / Mahindra Powerol / Ashok Leyland / Eicher / Greaves Cotton</p>
                                    <p><BsCheck /> Frequency: 50 Hz / 60 Hz</p>
                                    <p><BsCheck /> Phase: Three Phase</p>
                                    <p><BsCheck /> Cooling System: Air Cooled / Water Cooled</p>
                                    <p><BsCheck /> Emission Standards: As per applicable international and project requirements</p>
                                    <h6>Contact Us <FiArrowUpRight /></h6>
                                </div>
                            </a>
                        </div>
                        <div className='OurservofferBoxSrvIner'>
                            <a href="/contact-us">
                                <div className='OurservofferBoxSrvImg'>
                                    <img src={DieselGenratorImg3} alt="Medium Horsepower Diesel Generator Sets" />
                                </div>
                                <div className='OurservofferBoxSrvTxt'>
                                    <h3>Medium Horsepower (MHP) Diesel Generator Sets</h3>
                                    <p>Range: 180 kVA - 500 kVA <FiArrowUpRight /></p>
                                </div>
                                <div className='OurservofferBoxSrvBox'>
                                    <h3>Medium Horsepower (MHP) DG Sets</h3>
                                    <p><BsCheck /> Output Voltage: 110V to 415V (Standard LV Supply), 11kV available through step-up transformer solutions</p>
                                    <p><BsCheck /> Engine: Cummins / Perkins / Volvo Penta / Kirloskar / Mahindra Powerol / Ashok Leyland</p>
                                    <p><BsCheck /> Frequency: 50 Hz / 60 Hz</p>
                                    <p><BsCheck /> Phase: Three Phase</p>
                                    <p><BsCheck /> Cooling System: Water Cooled</p>
                                    <p><BsCheck /> Emission Standards: As per applicable international and project requirements</p>
                                    <h6>Contact Us <FiArrowUpRight /></h6>
                                </div>
                            </a>
                        </div>
                        <div className='OurservofferBoxSrvIner'>
                            <a href="/contact-us">
                                <div className='OurservofferBoxSrvImg'>
                                    <img src={DieselGenratorImg4} alt="High Horsepower Diesel Generator Sets" />
                                </div>
                                <div className='OurservofferBoxSrvTxt'>
                                    <h3>High Horsepower (HHP) Diesel Generator Sets</h3>
                                    <p>Range: 500 kVA - 3750 kVA+ <FiArrowUpRight /></p>
                                </div>
                                <div className='OurservofferBoxSrvBox'>
                                    <h3>High Horsepower (HHP) DG Sets</h3>
                                    <p><BsCheck /> Output Voltage:  415V (LV) / 11kV (HV) configurations available</p>
                                    <p><BsCheck /> Frequency: 50 Hz / 60 Hz</p>
                                    <p><BsCheck /> Phase: Three Phase</p>
                                    <p><BsCheck /> Cooling System: Water Cooled</p>
                                    <p><BsCheck /> Operation Mode: Prime Power / Continuous Power / Standby Power</p>
                                    <p><BsCheck /> Configuration: Open Type / Silent (Acoustic Enclosure) Type / Containerised DG Sets</p>
                                    <p><BsCheck /> Engine Make: Cummins / Perkins / Caterpillar / Volvo Penta / Kirloskar (as per requirement)</p>
                                    <p><BsCheck /> Emission Standards: As per applicable international and project requirements</p>
                                    <h6>Contact Us <FiArrowUpRight /></h6>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className='CustContainer'>
                <div className='OurInfrsDatacov'>
                    <h2>Our Associate Partners</h2>
                    <p>We collaborate with globally recognized engine manufacturers to deliver reliable and highperformance diesel generator solutions. Our DG sets are powered by trusted brands known for their quality, durability, and efficiency. </p>
                    <Slider {...settings}>
                        <div className='OurInfrsDataMain'>
                            <div className='OurInfrsDataIner'>
                                <img src={PartnerLogoOne} alt="Filtration Machine" />
                                
                            </div>
                        </div>
                        <div className='OurInfrsDataMain'>
                            <div className='OurInfrsDataIner'>
                                <img src={PartnerLogoTwo} alt="Filtration Machine" />
                                
                            </div>
                        </div>
                        <div className='OurInfrsDataMain'>
                            <div className='OurInfrsDataIner'>
                                <img src={PartnerLogoThree} alt="Filtration Machine" />
                                
                            </div>
                        </div>
                        <div className='OurInfrsDataMain'>
                            <div className='OurInfrsDataIner'>
                                <img src={PartnerLogoFour} alt="Filtration Machine" />
                                
                            </div>
                        </div>
                        <div className='OurInfrsDataMain'>
                            <div className='OurInfrsDataIner'>
                                <img src={DieselGenratorFive} alt="Filtration Machine" />
                                
                            </div>
                        </div>
                        
                    </Slider>
                </div>
            </div>

            <ConsultationForm />

            <div className='CustContainer'>
                <div className='HomepgTitleCov'>
                    <h3>Frequently Asked Question</h3>
                </div>
                <div className='faqPageBotset'>
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>1. What is a Diesel Generator?</Accordion.Header>
                            <Accordion.Body>
                                <p>A <span>diesel generator (DG set)</span> is a power generation system that uses a diesel engine coupled with an alternator to produce electricity. It is widely used for <span>backup power (standby)</span> as well as <span>continuous power (prime power)</span> in industrial, commercial, and infrastructure applications, ensuring reliable electricity supply during outages or in remote locations.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>2. What is a Silent Diesel Generator?</Accordion.Header>
                            <Accordion.Body>
                                <p>A <span>silent diesel generator</span> is a generator set enclosed within an <span>acoustic (soundproof) canopy,</span> designed to reduce noise levels during operation. These generators are ideal for <span>urban areas, commercial buildings, hospitals, and residential applications,</span> where low noise and environmental compliance are required. </p>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>3. What is a Mobile Generator?</Accordion.Header>
                            <Accordion.Body>
                                <p>A <span>mobile generator</span> is a diesel generator mounted on a <span>trailer or movable skid platform,</span> allowing easy transportation between locations. It is commonly used in <span>construction sites, emergency applications, temporary power supply, and remote project locations,</span> where flexible and portable power is required.</p>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>

            <BlogList />

            <Continent />
        </div>
    );
}

export default DieselGenerator;
